module.exports = __webpack_public_path__ + "img/payrite.866050bb.png";